export default {
  internalTeachers: [],
  externalTeachers: [],
  teachers: [],
  students: [],
  teachersCount: 0,
  studentsCount: 0,
  unreadNotificationsCount: 0,
  unreadChatsCount: 0,
  notifications: [],
  notificationsLastPage: 1,
  notificationsCurrentPage: 1,
  studentsRegistationX: [],
  studentsRegistationY: [],
}
